define('imovelcliente-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
    var app = angular.module('imovelcliente.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('Imovelcliente', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {
                saveImg: function(data) {
                    return $http.post(appRoute.linkTo('imovelcliente.uploadImg'), data).then(function(result){
                        return result;
                    });
                },
                getImoveis: function(data) {
                    return $http.post(appRoute.linkTo('imovelcliente.getImoveis'), data).then(function(result){
                        return result;
                    });
                },
                createThumb: function(imo_codigo) {
                    return $http.get(appRoute.linkTo('imovelcliente.createThumb', {'imou_codigo':imou_codigo}));
                },
                create:function(data){
                    return $q(function (resolve, reject) {
                        return $http.post(appRoute.linkTo('imovelcliente.create'), data).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },
                getCidadeByEstado:function (est_codigo) {//index de amostra
                    return $q(function (resolve, reject) {
                        $http.get(appRoute.linkTo('imovelcliente.getCidadeByEstado', {'est_codigo':est_codigo})).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            if (error && error.notifications && !_.isEmpty(error.notifications)) {
                                //notify.addNotification(error.notifications);
                            } else {
                                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
                            }
                            reject(error);
                        });
                    });
                },
                successUploadImgImovelusuario:function(data){
                    return $q(function (resolve, reject) {
                        return $http.post(appRoute.linkTo('imovelcliente.successUploadImgImovelusuario'), data).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                saveDoc: function(data) {
                    return $http.post(appRoute.linkTo('imovelcliente.uploadDoc'), data).then(function(result){
                        return result;
                    });
                },

                successUploadDocImovelusuario:function(data){
                    return $q(function (resolve, reject) {
                        return $http.post(appRoute.linkTo('imovelcliente.successUploadDocImovelusuario'), data).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                buscarEnderecoPorCEPSite: function(cep) {
                    return $http.get(appRoute.linkTo('imovelcliente.buscarEnderecoPorCEPSite', cep));
                },

                gerarTermoImovelUsuario:function(data){
                    return $q(function (resolve, reject) {
                        return $http.post(appRoute.linkTo('imovelcliente.gerarTermoImovelUsuario'), data).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                enviarCopiaTermoEmail:function(data){
                    return $q(function (resolve, reject) {
                        return $http.post(appRoute.linkTo('imovelcliente.enviarCopiaTermoEmail'), data).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

            }
        }
    ]);
});


